<template>
  <v-app-bar class="pa-1 wgu-app-toolbar onprimary--text" color="primary" style="display: flex;">

    <!-- slot to inject components at the beginning (before title) -->
    <slot name="wgu-tb-start"></slot>

    <div class="ml-4 title-box">
      <p class="ma-2 pl-2 pr-2 title-text">
      {{ $t('app.title') }}
      </p>
    </div>

    <!-- slot to inject components after the title text -->
    <slot name="wgu-tb-after-title"></slot>

    <v-spacer></v-spacer>

    <!-- slot to inject components before the auto-generated buttons (by config) -->
    <slot name="wgu-tb-before-auto-buttons"></slot>

    <template v-for="(tbButton, index) in tbButtons" :key="index">
      <component :is="tbButton.type" v-bind="tbButton" />
    </template>

    <!-- slot to inject components after the auto-generated buttons (by config) -->
    <slot name="wgu-tb-after-auto-buttons"></slot>

    <v-menu v-if="menuButtons.length" eager offset="15" class="header-menu">
      <template v-slot:activator="{ props }">

        <v-btn icon v-bind="props" class="wgu-menu-button" color="on-primary" :title="$t('wgu-toolbar-menu.title')">
          <v-icon size="medium">md:menu</v-icon>
        </v-btn>
      </template>
      <v-list color="primary">
        <template v-for="(tbButton, index) in menuButtons" :key="index">
          <v-list-item class="py-0">
            <component :is="tbButton.type" :key="index" v-bind="tbButton" />
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <!-- slot to inject components at the end of the toolbar (after menu) -->
    <slot name="wgu-tb-end"></slot>

    <!-- Steb Logo -->
    <a href="https://steb-koeln.de" class="logo" target="_blank">
      <img :src=logo style="height: 100%" class="pa-1" />
    </a>

  </v-app-bar>
</template>

<script>

import { useDisplay } from 'vuetify';
import ToggleButton from '../../src/components/modulecore/ToggleButton'
import ZoomToMaxExtentButton from '../../src/components/maxextentbutton/ZoomToMaxExtentButton'
import Geocoder from '../../src/components/geocoder/Geocoder'
import Geolocator from '../../src/components/geolocator/Geolocator'
import LocaleSwitcher from '../../src/components/localeswitcher/LocaleSwitcher'
import ThemeSwitcher from '../../src/components/themeswitcher/ThemeSwitcher'
import InfoButton from './InfoButton/InfoButton.vue'
import { WguEventBus } from '../../src/WguEventBus'

export default {
  name: 'wgu-app-header',
  components: {
    'wgu-toggle-btn': ToggleButton,
    'wgu-geocoder-btn': Geocoder,
    'wgu-zoomtomaxextent-btn': ZoomToMaxExtentButton,
    'wgu-geolocator-btn': Geolocator,
    'wgu-localeswitcher-btn': LocaleSwitcher,
    'wgu-themeswitcher-btn': ThemeSwitcher,
    'wgu-infobutton-btn': InfoButton
  },
  props: {},
  setup () {
    const { name } = useDisplay();
    const vueDisplayInfo = name.value;
    return { vueDisplayInfo };
  },
  data () {
    const urlObj = new URL(window.location.href)

    if (urlObj.searchParams.get('Module')) {
      if (this.$appConfig.TopicList.indexOf(urlObj.searchParams.get('Module')) >= 0) {
        this.$appConfig.TopicDefault = urlObj.searchParams.get('Module')
      }
    }

    return {
      menuButtons: this.getModuleButtons('menu'),
      tbButtons: this.getModuleButtons('toolbar'),
      tbButtonsStarkregenOnly: this.getModuleButtons('toolbarStarkregenOnly'),
      topicActive: this.$appConfig.TopicDefault,
      logo: this.$appConfig.logoHeader
    }
  },
  methods: {
    /**
     * Determines the module button configuration objects from app-config:
     * If the module button toggles a window, then a generic wgu-toggle-btn will
     * be returned - otherwise the button is custom.
     *
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @param  {String} target Either 'menu' or 'toolbar'
     * @return {Array} module button configuration objects
     */
    getModuleButtons (target) {
      const appConfig = this.$appConfig || {};
      const modulesConfs = appConfig.modules || {};
      const buttons = [];
      for (const key of Object.keys(modulesConfs)) {
        const moduleOpts = appConfig.modules[key];

        if (moduleOpts.target === target ||
             (target === 'menu' && moduleOpts.target === 'toolbar_onsmall_menu' && moduleOpts.breakpoint && moduleOpts.breakpoints_for_menu.includes(this.vueDisplayInfo)) ||
             (target === 'toolbar' && moduleOpts.target === 'toolbar_onsmall_menu' && moduleOpts.breakpoints_for_menu && !moduleOpts.breakpoints_for_menu.includes(this.vueDisplayInfo))
        ) {
          buttons.push({
            type: moduleOpts.win ? 'wgu-toggle-btn' : key + '-btn',
            moduleName: key,
            ...moduleOpts
          });
        }
      }
      return buttons;
    },
    topicButtonClicked (t) {
      // console.log('Topicbutton clicked');
      // console.log(t);

      this.topicActive = t;

      WguEventBus.$emit('layerList-topicButton', t);
      WguEventBus.$emit('infoButton-topicButton', t);
    }
  }
}
</script>

<style>
.v-toolbar__content {
  height: 74px !important;
}

@media (max-width: 1264px) {
  .wgu-app-toolbar .v-toolbar__content {
    padding-right: 4px !important;
    padding-left: 32px !important; /* beim Wechsel der Sidebar Abstand vergrößern */
  }
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
  }
  .v-toolbar__content .v-btn.v-btn--icon.v-size--default {
    width: 36px !important;
  }
  .v-btn-toggle .v-btn.v-btn.v-size--default {
    width: 36px !important;
    min-width: 36px !important;
  }
}

@media (max-width: 600px) {
  .v-toolbar__content .v-btn.v-btn--icon.v-size--default {
    width: 30px !important;
  }
  .v-btn-toggle .v-btn.v-btn.v-size--default {
    width: 30px !important;
    min-width: 30px !important;
  }
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.logo {
  margin-left: 20px;
  height: 70%;
}

@media (min-width: 960px) {
  .buttonBorder {
    /* border: solid 1px #0061A0 !important; */
    border: solid 2px rgb(127, 176, 208)!important;
    margin-left: 4px !important;
  }

}
@media (max-width: 960px) {
  .buttonBorder {
    /* border: solid 1px #0061A0 !important; */
    border: solid 2px rgb(127, 176, 208)!important;
    margin-left: 0px !important;
  }
}

@media (max-width: 1450px) {
  .adjustPadding {
    padding: 0 10px !important;
    letter-spacing: 1px;
  }
}

@media (max-width: 1200px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
  }
  .logo {
    margin-left: 8px;
  }
}

@media (max-width: 1000px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: -1px;
  }

  .logo {
    margin-left: 4px;
    height: 50%;
  }

  .title-box {
    font-size: 90%;
    letter-spacing: 0;
  }
}

@media (max-width: 800px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
  }

  .logo {
    margin-left: 0px;
    height: 40%;
  }

  .title-box {
    width: 0;
    visibility: hidden;
  }
  .header-spacer {
    width: 0;
    visibility: hidden;
  }
  .wgu-geocoder-combo {
    max-width: 150px !important;
  }
}

@media (max-width: 600px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
  }
  .logo {
    order: 1;
  }
}

@media (max-width: 550px) {
  .logo { /* wenn Buttons reduziert werden kann Logo bleiben */
    margin-left: 0px;
    display: none;
  }
}

@media (max-width: 480px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
  }

  .logo {
    margin-left: 0px;
    display: none;
  }
}

</style>
